import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { Box, LinearProgress } from "@material-ui/core";
import Details from "components/EmailEventDetails";
import { PropertyData } from "components/EmailEventDetails/styled";
import { useFetch } from "utils/api/useFetch";

import { EmailFlowLogDetails, NotificationEvent } from "@dashboard-v3/api";

interface Props {
  onError: () => void;
  notification: NotificationEvent;
  expanded: boolean;
}

export default function EmailDetails(props: Props) {
  const { expanded, notification, onError } = props;
  const { t } = useTranslation(["notifications", "tracing"]);
  const { enqueueSnackbar } = useSnackbar();
  const { data } = notification;
  const detailsCacheKey = expanded
    ? `/emailflow-logs/details/${data.msgUID}`
    : null;
  const { data: items, isLoading } = useFetch<EmailFlowLogDetails[]>(
    detailsCacheKey,
    {
      fallbackData: [],
      onError: () => {
        enqueueSnackbar(t("tracing:error.fetchItemEvents"), {
          variant: "error",
        });
        onError();
      },
    }
  );

  if (isLoading) {
    return (
      <Box mt={6}>
        <LinearProgress />
      </Box>
    );
  }

  if (!data.msgUID) {
    return (
      <PropertyData color="textPrimary">
        {t("notifications:emptyMsgUID")}
      </PropertyData>
    );
  }

  return <Details details={items} showSplitRecipientStatus={true} includeAll />;
}
